export default [
  {
    path: "/login",
    component: () => import("@/layout/Login"),
    children: [
      {
        name: "login",
        path: "",
        component: () => import("./pages/Login"),
        meta: {
          title: "Login",
          logged_out: true,
        },
      },
      {
        name: "novo-usuario",
        path: "novo-usuario",
        component: () => import("./pages/NovoUsuario"),
        meta: {
          title: "Cadastre-se",
          logged_out: true,
        },
      },
      {
        name: "esqueceu-senha",
        path: "esqueceu-senha",
        component: () => import("./pages/EsqueceuSenha"),
        meta: {
          title: "Esqueci a senha",
          logged_out: true,
        },
      },
      {
        name: "reenviar-email-confirmacao",
        path: "reenviar-email-confirmacao",
        component: () => import("./pages/ReenviarEmail"),
        meta: {
          title: "Reenviar e-mail",
          logged_out: true,
        },
      },
      {
        name: "reset-password",
        path: "reset-password",
        component: () => import("./pages/ResetPassword"),
        meta: {
          title: "Trocar senha",
          logged_out: true,
        },
      },
    ],
  },
];
